<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="grid-view"
    type="primary"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item v-if="isUserIpConfig" :label="$t('SystemMaintenance.User')">
                <cargo-advance-select
                  ref="userSelect"
                  basic-data-user
                  :select-type="selectTypeNames.basic_data_User"
                  :callback-params="{key:'userId'}"
                  callback-method-type="value"
                  :default-value="oneForm.userId"
                  tag-value="userId"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName','englishName','login']"
                  filterable
                  style="width:205px;"
                  options-width="230px"
                  @parentCallBack="oneForm.userId = $event.value"
                />
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.IPAddress')">
                <el-input
                  v-model="oneForm.ipName"
                  style="width: 260px"
                  size="mini"
                  :placeholder="$t('SystemMaintenance.PleaseEnterTheIPAddress')"
                />
              </el-form-item>
              <el-form-item>
                <div class="triggers">
                  <el-button size="mini" type="primary" :disabled="!isIp" @click="add">添加</el-button>
                  <el-button size="mini" type="danger" @click="del">{{ $t('SystemMaintenance.Delete') }}</el-button>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;"
        />
      </div>
    </div>
  </div>

</template>

<script>

import { validIp } from '@/utils/validate'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import { getDropdownUser } from '@/api/user'
import { getIpWhiteList, addIpWhite, delIpWhite } from '@/api/ipConfigFilter'
import { getGridSelected } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'IpWhiteList',
  components: { cargoAdvanceSelect },
  props: {
    type: { type: String, default: 'global' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      userList: [],
      oneForm: {
        userId: '',
        ipName: ''
      },
      currentOfficeUuid: '',
      fullscreenLoading: false,
      gridOptions: {},
      gridApi: {},
      columnDefs: null,
      rowData: []
    }
  },
  computed: {
    url() {
      return URL
    },
    currentOfficeId() {
      console.log('computed currentOfficeId', this.$store.getters.currentOfficeId)
      return this.$store.getters.currentOfficeId
    },
    isUserIpConfig() {
      return this.type === 'user'
    },
    isIp() {
      if (this.isUserIpConfig) {
        return this.oneForm.ipName && (this.oneForm.ipName === '*' || validIp(this.oneForm.ipName))
      } else {
        return this.oneForm.ipName && validIp(this.oneForm.ipName)
      }
    }
  },
  watch: {
    async currentOfficeId() {
      await cache.load(cacheName.OFFICE)
      this.currentOfficeUuid = cache.office.uuid
    }
  },
  beforeMount() {
    this.columnDefs = []
    if (this.isUserIpConfig) {
      this.columnDefs.push({
        headerName: this.$t('SystemMaintenance.User'),
        field: 'userId',
        width: 280,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      })
    } else {
      this.columnDefs.push({
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      })
    }
    this.columnDefs.push({
      headerName: `ip地址${this.isUserIpConfig ? '(*表示不受限制)' : ''}`,
      field: 'ip',
      width: 280
    })

    this.gridOptions = {
      rowSelection: this.isUserIpConfig ? 'single' : 'multiple',
      suppressRowClickSelection: false,
      suppressCellSelection: true
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      Promise.all([getDropdownUser({ pageSize: 10000 }), getIpWhiteList(this.type)]).then(([userListRes, ipListRes]) => {
        this.userList = userListRes.data
        this.rowData = ipListRes.data
      })
    },
    toCheckForm() {
      let errors = ''
      let isExists = false
      if (!this.oneForm.ipName.trim()) {
        errors = this.$t('SystemMaintenance.IPAddressCannotBeEmpty')
      }
      if (this.isUserIpConfig) {
        // todo
        if (!this.oneForm.userId) {
          errors = this.$t('SystemMaintenance.PleaseSelectAUser')
        }
        isExists = !!this.rowData.find(row => {
          return row.userId === this.oneForm.userId && row.ip === this.oneForm.ipName
        })
        errors = isExists ? this.$t('SystemMaintenance.ThisAlreadyAddedAnWhitelist') : errors
      } else {
        this.oneForm.userId = null
        isExists = !!this.rowData.find(row => {
          return row.ip === this.oneForm.ipName
        })
        errors = isExists ? this.$t('SystemMaintenance.ExistingSameIPAddress') : ''
      }
      if (errors) {
        this.$message.error(errors)
        return false
      }
      return true
    },
    add() {
      if (this.toCheckForm()) {
        const data = { userId: this.oneForm.userId, ipAddresses: [this.oneForm.ipName] }
        addIpWhite([data], this.type).then(res => {
          this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
          this.oneForm.ipName = ''
          if (this.isUserIpConfig) {
            this.$refs.userSelect.toClear()
          }
          this.fetchList()
        })
      }
    },
    del() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length > 0) {
        const ipAddresses = rows.map(item => item.ip)
        const userId = this.isUserIpConfig ? rows[0].userId : ''
        const data = { userId, ipAddresses }
        delIpWhite(data).then(res => {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.fetchList()
        })
      } else {
        this.$message.error(this.$t('SystemMaintenance.PleaseSelectData'))
      }
    }
  }
}
</script>

<style scoped>

</style>
